export default "__VITE_ASSET__cf461b25__"